import { configuration } from "../config/configurations";

const config: any = configuration();
export const apiEndPoints = {
    "baseURL": `${config.baseURL}/api`,
    "requestOTPEndPoint": `${config.baseURL}/auth/request-otp`,
    "verifyOTPEndPoint": `${config.baseURL}/auth/verify-otp`,
    "reSendOTPEndPoint": `${config.baseURL}/auth/resend-otp`,
    "hospitalsEndPoint": `${config.baseURL}/api/hospitals`,
    "hospitalsBulkUploadEndPoint": `${config.baseURL}/api/hospitals/bulk-upload`,
    "referralsHospitalEndPoint": `${config.baseURL}/api/referrals/hospital`,
    "hospitalFilterEndPoint": `${config.baseURL}/api/hospitals/filter`,
    "referralPatientEndPoint": `${config.baseURL}/api/referrals/patient`,
    "referralsFilterEndPoint": `${config.baseURL}/api/referrals/filter`,
    "visionAmbassadorsURL": `${config.baseURL}/api/vision-ambassadors/filter`,
    "ambassadorReferralURL": `${config.baseURL}/api/referrals/ambassador`,
    "spectacleRequestsURL": `${config.baseURL}/api/referrals/bulk-update`,
    "deleteUserAccountURL": `${config.baseURL}/api/vision-ambassadors`,
};